document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-marcas-carousel]').forEach(function (wrap) {
    var section = wrap.closest('.shopify-section--marcas-carousel') || wrap.closest('section');
    var track = wrap.querySelector('[data-marcas-track]');
    if (!track) return;

    // Velocidade opcional via atributo data-speed no wrapper (definida no schema, se ligada)
    var speed = wrap.dataset.speed;
    if (speed) {
      track.style.setProperty('--marcas-speed', speed + 's');
    }
  });
});